import { createReducer, on } from '@ngrx/store';
import * as OrderValidationActions from './order-validation.actions';

export interface OrderValidationState {
  response: any | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: any };
}

export const initialState: OrderValidationState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const orderValidationReducer = createReducer(
  initialState,
  on(OrderValidationActions.loadOrderValidation, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(OrderValidationActions.loadOrderValidationSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(OrderValidationActions.loadOrderValidationFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(OrderValidationActions.loadOrderValidationSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
);
